// Android WebView (Capacitor) throttluje requestAnimationFrame w bezczynności.
// Po PROGRAMOWYM navigate (np. po await logowania, bez gestu) framer-owe przejście tras
// (<AnimatePresence mode="wait">) nie startuje i nowa trasa nie montuje się do czasu gestu
// (login "wisi", odwiesza się po kliknięciu czegokolwiek).
//
// Krótki heartbeat rAF trzyma pętlę klatek żywą przez czas przejścia, żeby się dokończyło.
// To PUSTE rAF (NIE animacja framer-motion) — dlatego nie blokuje AnimatePresence
// (w przeciwieństwie do nieskończonego motion-spinnera, który blokował mode="wait").
export const wakeRafBriefly = (ms = 700) => {
  if (typeof requestAnimationFrame !== 'function' || typeof performance === 'undefined') return;
  const start = performance.now();
  const tick = () => {
    if (performance.now() - start < ms) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
};
